// extracted by mini-css-extract-plugin
export default {"p_content":"b165a86b18"};